import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface CouponSectionProps {
    loading: boolean
    onApplyCoupon: (code: string) => void
}

export const CouponSection = ({ loading, onApplyCoupon }: CouponSectionProps) => {
    const [couponCode, setCouponCode] = useState('')

    const handleApply = () => {
        if (couponCode) {
            onApplyCoupon(couponCode)
            setCouponCode('')
        }
    }

    return (
        <div className="flex items-center gap-2">
            <Input
                placeholder="Enter coupon code"
                aria-label="Coupon code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                className="flex-1"
                onKeyDown={(e) => e.key === 'Enter' && handleApply()}
            />
            <Button
                variant="secondary"
                onClick={handleApply}
                disabled={!couponCode || loading}>
                Apply
            </Button>
        </div>
    )
}
